const TableHeightHook = {
  mounted() {
    table_height = this.el.clientHeight;

    this.pushEventTo(this.el, 'table_height', table_height);
  }
}

export default TableHeightHook;